var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.puzzle)?_c('div',{staticClass:"c-grid"},[_c('svg',{staticClass:"c-grid__svg",attrs:{"viewBox":`0 0 ${_vm.viewBoxWidth} ${_vm.viewBoxHeight}`}},_vm._l((_vm.puzzle.rows),function(item,index){return _c('PuzzleRow',{key:index,attrs:{"yIndex":index,"row":item}})}),1),_c('PuzzleGridInput')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }